import script from "./AiFloatingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AiFloatingButton.vue?vue&type=script&setup=true&lang=js"

import "./AiFloatingButton.vue?vue&type=style&index=0&id=d9edabfc&scoped=true&lang=css"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9edabfc"]])

export default __exports__